<template>
  <div class="dashboard">
    <!-- Modal for CMU Dictionary Download -->
    <div class="container">
      <!-- TEST -->

      <div class="header">
        <img class="icon" src="@/assets/exam.svg" />
        <h1 class="text">発音テスト</h1>
        <div class="header-description">音声認識を利用した独自の採点方法を用い、あなたの発音能力・英語力を測定します。</div>
      </div>

      <div class="test-ui">
        <div class="test-ui-inner-left">
          <!-- <div class="no-data">データがまだありません</div> -->
          <chartist
            ratio="ct-chart"
            style="font-weight:bold;"
            :style="`${this.noChartData ? 'filter: blur(5px)' : '' }`"
            type="Line"
            :data="modifiedChartData"
            :options="chartOptions"
          ></chartist>
          <div
            class="legend"
            :style="`${this.noChartData ? 'filter: blur(3px)' : '' }`"
          >テスト結果の推移({{new Date().getFullYear()}}年)</div>
        </div>

        <div class="test-ui-inner-right">
          <div class="your-score">これまでの最高スコア</div>
          <div class="max-score">
            <div v-show="!maxScore">未受験</div>
            <AnimatedNumber v-show="maxScore" class="max-score" :value="maxScore" />
          </div>
          <div
            class="time"
            :style="`${this.noChartData ? 'filter: blur(3px)' : '' }`"
          >{{`${maxDate.getFullYear()}年${maxDate.getMonth() + 1}月${maxDate.getDate()}日${maxDate.getHours()}時${maxDate.getMinutes()}分`}}</div>
          <router-link :to="{name: 'Test'}">
            <button
              class="button"
              style="margin-top: 30px;vertical-align:middle; padding: 8px 16px; font-size: .92rem;"
            >
              <img
                src="@/assets/logo-white.svg"
                style="vertical-align:middle; margin-top: -2px"
                width="100px"
              />
              テストを受験する
            </button>
          </router-link>
        </div>
      </div>

      <div>
        <div class="header">
          <img class="icon" src="@/assets/blackboard.svg" />
          <h1 class="text">発音レッスン</h1>

          <div class="header-description">英語の発音記号の発音方法を、独自のメソッドとわかりやすい3D映像で解説しています。</div>
        </div>

        <div class="phoneme-type-container">
          <div
            class="phoneme-type-border"
            style="border-radius: 5px; overflow: hidden;border: 1px solid #555; display:inline-block;"
          >
            <div
              class="phoneme-type"
              :class="{'active': phonemeType === 'consonant'}"
              @click="changePhonemeType('consonant')"
            >子音編</div>
            <div
              class="phoneme-type"
              :class="{'active': phonemeType === 'vowel'}"
              @click="changePhonemeType('vowel')"
            >母音編</div>
            <i class="el-icon-search"></i>
            <input type="text" placeholder="単語から検索..." v-model="lessonSearch" />
          </div>
        </div>

        <div style="text-align: center">
          <div class="lesson-search" v-show="searchResult">
            <div class="target-label">検索対象</div>
            {{searchResult}}
          </div>
        </div>

        <div class="lesson-item-list">
          <div v-for="(lesson, index) in lessons" :key="index">
            <div v-show="lessonVisibleCondition(lesson)">
              <LessonBlock
                @click="goToLesson(lesson)"
                :key="index"
                :lesson="lesson"
                :lock="!lesson.premium"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// import { db } from "@/main";
// import Dexie from "dexie";
import Vue from "vue";
import axios from "axios";
import pronDict from "@/utils/PronDictionary";
import resultRepo from "@/utils/TestResultRepository";
import problemResultRepo from "@/utils/ProblemResultRepository";
import { CLEAR_SCORE } from "@/constants";

Vue.use(require("vue-chartist"));

const lessons = require("@/resources/lessons.json");
const problems = require("@/resources/workbooks.json");

// Vue.component(
//   "LessonProgressCircle",
//   require("@/components/LessonProgressCircle").default
// );

export default {
  name: "Dashboard",
  components: {
    LessonBlock: require("./LessonBlock").default,
    Footer: require("@/components/Footer").default,
    AnimatedNumber: require("@/components/AnimatedNumber").default
  },
  computed: {
    lessonVisibleCondition() {
      return lesson => {
        if (this.phonemeType === "search") {
          return true;
          // return searchPhonemes.map(ph => {
          //   return lesson.targetPhoneme === ph;
          // });
        } else {
          this.lessons = lessons;
          return lesson.category === this.phonemeType;
        }
      };
    },
    modifiedChartData() {
      if (this.chartData.series.length > 0) {
        return {
          series: this.chartData.series,
          labels: this.chartData.series[0].map((s, index) => {
            return index.toString();
          })
        };
      } else {
        return {
          series: this.mockChartData.series,
          labels: this.mockChartData.series[0].map((s, index) => {
            return index.toString();
          })
        };
      }
    }
  },
  watch: {
    lessonSearch(text) {
      let self = this;
      pronDict.getIpaFromSingleText(text).then(result => {
        // find IPA from text
        const searched = result
          .map(word => {
            if (word) {
              return word
                .map(ph => {
                  return ph.withStress;
                })
                .join("");
            }
          })
          .join(" ");
        this.searchResult = searched;

        // find used phonemes
        let searchPhonemes = [];
        result.forEach(word => {
          if (word) {
            word.forEach(ph => {
              searchPhonemes.push(ph.withoutStress);
            });
          }
        });

        if (searchPhonemes.length > 0) {
          this.phonemeType = "search";
          this.searchPhonemes = searchPhonemes;

          const selectedLessons = searchPhonemes.map(ph => {
            return lessons.filter(lesson => {
              return lesson.targetPhoneme === ph;
            })[0];
          });
          this.lessons = selectedLessons;
        }
      });
    }
  },
  data() {
    return {
      maxScore: 0,
      maxDate: new Date(),
      noChartData: true,
      chartData: {
        series: []
      },
      mockChartData: {
        series: [[4213, 5355, 7543, 7200, 8024, 8400]]
      },
      chartOptions: {
        axisX: {
          labelInterpolationFnc: function(value, index, label) {
            if (label.length > 20 && label.length <= 40) {
              return index % 2 === 0 ? value : null;
            } else if (label.length > 40) {
              return index % 10 === 0 ? value : null;
            } else {
              return value;
            }
          }
        },
        lineSmooth: this.$chartist.Interpolation.simple({
          divisor: 2,
          fillHoles: false
        }),
        height: "350px",
        chartPadding: {
          top: "30px"
        }
      },
      problems: null,
      showTabs: {
        consonants: false,
        vowels: false
      },
      lessons: [],
      allLessons: [],
      searchResult: null,
      lessonSearch: "",
      highestScore: 4034,
      phonemeType: "consonant",
      searchPhonemes: [],
      problemResults: {}
    };
  },

  mounted() {
    document.title = `PronAid | ダッシュボード`;
    let self = this;
    this.lessons = lessons;

    const results = resultRepo.getResults().then(results => {
      let highestScore = 0;
      let highestDate = new Date();
      const resultsArray = results.map(result => {
        if (highestScore < result.score) {
          highestScore = result.score;
          highestDate = result.createdAt;
        }
        return result.score;
      });

      if (resultsArray.length > 0) {
        self.noChartData = false;
      }

      self.maxScore = highestScore;
      self.maxDate = highestDate;

      self.chartData.series.push(resultsArray);
    });
  },
  methods: {
    spliceAndPushLessons(prev, next) {},
    changePhonemeType(type) {
      this.phonemeType = type;
    },
    goToLesson(lesson) {
      this.$router.push({
        path: "lesson",
        query: { category: lesson.titlePhoneme }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  /* padding-bottom: 500px; */
}
.test-ui {
  border-radius: 6px;
  width: 100%;
  height: 400px;
  margin-bottom: 20px;
  padding: 20px 30px;
  box-sizing: border-box;
  .test-ui-inner-left {
    height: 100%;
    width: 65%;
    float: left;
    position: relative;
    .no-data {
      position: absolute;
      top: 165px;
      left: 200px;
      padding: 10px 60px;
      border-radius: 5px;
      background-color: #eee;
      z-index: 30;
      font-weight: bold;
      background-size: auto auto;
      background-color: rgba(255, 255, 255, 1);
      background-image: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 5px,
        rgba(235, 235, 235, 1) 5px,
        rgba(235, 235, 235, 1) 6px
      );
    }
    .legend {
      position: absolute;
      display: inline-block;
      bottom: -35px;
      left: 50%;
      transform: translateX(-50%);
      font-weight: 600;
      background-color: #fff;
      border-radius: 3px;
      padding: 3px;
      z-index: 50;
      font-size: 1rem;
    }
    .chart {
      height: 380px !important;
      margin: auto;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      padding: 10px;
      box-sizing: border-box;
    }
  }
  .test-ui-inner-right {
    height: 100%;
    float: right;
    margin-top: 80px;
    width: 35%;
    text-align: center;
    font-weight: 600;
    .your-score {
      font-size: 1.1rem;
    }
    .max-score {
      font-size: 3rem;
      font-weight: 800;
    }
  }
}

.header {
  display: inline-block;
  width: 100%;
  margin: 20px 0 0 50px;
  h1 {
    margin: 5px 0;
    font-size: 1.9rem;
  }
  .header-description {
    display: block;
    margin-bottom: 20px;
    font-size: 1rem;
    font-weight: bold;
  }
  img,
  .text {
    vertical-align: middle;
    display: inline-block;
  }

  img {
    width: 38px;
    margin-right: 10px;
  }
}

.lesson-item-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0;
  justify-content: center;
  align-items: center;
}

.phoneme-type {
  cursor: pointer;
  text-align: center;
  z-index: 300;
  font-size: 1.1rem;
  display: inline-block;
  margin: 0 auto;
  padding: 5px 20px;
  background-color: white;
  color: #555;
  &:hover {
    background-color: #777;
    color: white;
  }
}

.active {
  background-color: #555;
  color: white;
}

.phoneme-type-container {
  margin: 15px 0;
  font-weight: bold;
  text-align: center;
  position: relative;
  i {
    color: #555;
    transform: translateX(25px) translateY(-1px);
  }
  input[type="text"] {
    margin-left: 0px;
    padding-left: 35px;
    margin-right: 14px;
    border-radius: 3px;
    width: 150px;
    background-color: #f7f7f7;
    border: none;
    transition: all 0.3s ease;
    user-select: none;
    outline: none;
    display: inline-block;
    font-size: 1.1rem;
    color: #555 !important;
    font-family: "Noto Sans Japanese", Arial, sans-serif;

    &::placeholder {
      padding-left: 5px;
      /* font-weight: bold; */
      color: #888;
    }
    &:placeholder-shown {
    }
    &:focus {
      width: 250px;
      background-color: #eaeaea;
      @at-root .phoneme-type-container {
        i {
          /* color: #f88 !important;   */
        }
      }
    }
  }
}

.lesson-search {
  text-align: center;
  transition: all 1s ease;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 0 15px 0;
  background-color: #eee;
  padding: 5px 10px;
  border-b: 5px;
  display: inline-block;

  .target-label {
    font-size: 0.8rem;
  }
}
</style>
